export const GET_SINGLE_SELECTED_LOCATION_REQ = 'GET_SINGLE_SELECTED_LOCATION_REQ';
export const GET_SINGLE_SELECTED_LOCATION_SUCC = 'GET_SINGLE_SELECTED_LOCATION_SUCC';
export const GET_SINGLE_SELECTED_LOCATION_FAIL = 'GET_SINGLE_SELECTED_LOCATION_FAIL';
export const SET_SINGLE_LOCATION_FOR_EDIT = 'SET_SINGLE_LOCATION_FOR_EDIT';



export const SET_SINGLE_LOCATION_SATAS_FILTER = 'SET_SINGLE_LOCATION_SATAS_FILTER';